import { Box } from '@factorialco/deprecated-design-system'
import { F0ButtonToggle } from '@factorialco/f0-react'
import { Counter } from '@factorialco/f0-react/dist/experimental'
import { Comment } from '@factorialco/f0-react/icons/app'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useRoom } from 'modules/meetings/lib/hooks/useRoom'

export const ChatButton = () => {
  const { isChatOpen, setIsChatOpen, pendingMessagesCount } = useRoom()

  return (
    <Box position="relative">
      <F0ButtonToggle
        icon={Comment}
        label={
          isChatOpen
            ? i18n.t('meetings.room.control_bar.chat.close')
            : i18n.t('meetings.room.control_bar.chat.open')
        }
        onSelectedChange={() => {
          track(trackingEvents.meetings.ControlBarChatButton, {
            isChatOpen: !isChatOpen,
          })
          setIsChatOpen(!isChatOpen)
        }}
        size="lg"
        selected={isChatOpen}
      />
      {pendingMessagesCount > 0 && (
        <Box position="absolute" style={{ top: '-5px', right: '-5px' }}>
          <Counter size="sm" type="selected" value={pendingMessagesCount} />
        </Box>
      )}
    </Box>
  )
}
